<template>
    <div>
        <b-row>
            <b-col class="d-flex justify-content-between">
                <text-header-new>Коммерческие предложения</text-header-new>
                <ul class="tabs">
                    <li v-for="(tab, index) in tabs" :key="'key_' + index">
                        <router-link :to="{ name: 'QuotationRequestsOffersList', params: { cat: tab.path } }" exact>{{ tab.title }}</router-link>
                    </li>
                </ul>
            </b-col>
        </b-row>

        <b-pagination v-if="quotations && meta.total > 0 && meta.last_page > 1" v-model="meta.current_page" :per-page="meta.per_page" :total-rows="meta.total" align="center" class="my-1" />

        <template v-for="quotation in quotations">
            <cabinet-quotation-card-open :quotation="quotation" v-if="quotation.status.id === 'active'" :key="quotation.id" />
            <cabinet-quotation-card-closed :quotation="quotation" v-if="quotation.status.id === 'inactive'" :key="quotation.id" />
        </template>

        <b-pagination v-if="quotations && meta.total > 0 && meta.last_page > 1" v-model="meta.current_page" :per-page="meta.per_page" :total-rows="meta.total" align="center" class="my-1" @input="fillData" />

        <div v-else class="text-center mt-5">
            <img src="/images/empty_box.svg" alt="empty-data" />
            <p class="fs-14 grey-color my-4">По вашему запросу ничего не найдено</p>
        </div>
    </div>
</template>

<script>
import CabinetQuotationCardOpen from '@/components/cabinet/quotation-requests/parts/cabinet-quotation-card-open.vue';
import CabinetQuotationCardClosed from '@/components/cabinet/quotation-requests/parts/cabinet-quotation-card-closed.vue';

export default {
    name: 'cabinet-quotations-list',
    components: {
        CabinetQuotationCardOpen,
        CabinetQuotationCardClosed
    },
    data() {
        return {
            tabs: [
                {
                    title: 'Все',
                    path: 'all'
                },
                {
                    title: 'Активные',
                    path: 'active'
                },
                {
                    title: 'Завершенные',
                    path: 'finished'
                }
            ],
            page: 1,
            quotations: [],
            loading: true,
            sortOrder: [{ field: 'created_at', direction: 'asc' }],
            meta: {
                current_page: 1,
                per_page: 5,
                total: 0
            }
        };
    },
    async mounted() {
        await this.fillData();
        this.$scrollToTop();
    },
    methods: {
        async fillData() {
            this.loading = true;
            try {
                const response = await this.$api.cabinet.quotationRequests.getOfferList(this.$route.params.cat, this.meta.current_page);
                this.quotations = response.data;
                this.meta = response.meta;
            } catch {
                this.quotations = [];
            } finally {
                this.loading = false;
            }
        },
        async routeFetchData() {
            this.meta.current_page = 1;
            await this.fillData();
            this.$scrollToTop();
        }
    },
    watch: {
        $route: 'routeFetchData'
    }
};
</script>

<style scoped>
.tabs {
    list-style-type: none;
    padding: 0;
    margin: 0;
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: start;
    -webkit-align-items: flex-start;
    -moz-box-align: start;
    -ms-flex-align: start;
    align-items: flex-start;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -moz-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
}

.tabs li + li {
    padding-left: 20px;
}

.tabs li {
    font-size: 14px;
    border-bottom: 2px solid transparent;
    cursor: pointer;
    //border-bottom: 1px solid var(--grey-color);
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -moz-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -moz-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
}

.tabs li a {
    color: var(--grey-color);
    text-decoration: none;
    border-bottom: 2px solid transparent;
}

.tabs li .router-link-active {
    color: var(--green-color) !important;
    border-bottom: 2px solid var(--green-color) !important;
}
</style>
